export default __webpack_public_path__ + "static/media/arrow-down.bb03b6de.svg";